var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import BonusesAndPromotionsRu from './BonusesAndPromotionsRu';
import BonusesAndPromotionsEn from './BonusesAndPromotionsEn';
import BonusesAndPromotionsUz from './BonusesAndPromotionsUz';
import { getSubscribeStatus as getSubscribeStatusAction, createSubscribeCampaign as createSubscribeCampaignAction, } from '../../../actions/bonus/creators/subscribeCampaignAction';
import * as Language from '../../../constants/Language';
var BonusesAndPromotions = /** @class */ (function (_super) {
    __extends(BonusesAndPromotions, _super);
    function BonusesAndPromotions() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onSubscribe = function (type) {
            var dataObject = {
                'Type': type,
                'StartDate': moment().format('YYYY-MM-DDTHH:mm:ss')
            };
            _this.props.createSubscribeCampaignAction(dataObject);
        };
        return _this;
    }
    BonusesAndPromotions.prototype.componentDidMount = function () {
        if (this.props.authenticated) {
            this.props.getSubscribeStatusAction();
        }
    };
    BonusesAndPromotions.prototype.componentWillReceiveProps = function (nextProps) {
        var user = nextProps.user;
        if (user !== this.props.user) {
            if (Object.keys(user).length > 0 && user.constructor === Object) {
                this.props.getSubscribeStatusAction();
            }
        }
    };
    BonusesAndPromotions.prototype.shouldComponentUpdate = function (nextProps) {
        return this.props.user !== nextProps.user || this.props.bonusData !== nextProps.bonusData || this.props.languageId !== nextProps.languageId;
    };
    BonusesAndPromotions.prototype.render = function () {
        var _a = this.props, languageId = _a.languageId, bonusData = _a.bonusData, user = _a.user, client = _a.client, isVerified = _a.isVerified;
        var isAuthenticated = Object.keys(user).length > 0 && user.constructor === Object;
        var props = {
            isVerified: isVerified,
            bonusData: bonusData,
            client: client,
            user: user,
            isAuthenticated: isAuthenticated,
            onSubscribe: this.onSubscribe,
            getSubscribeStatusAction: getSubscribeStatusAction,
            createSubscribeCampaignAction: createSubscribeCampaignAction
        };
        switch (languageId) {
            case Language.EN:
                return _jsx(BonusesAndPromotionsEn, __assign({}, props));
            case Language.UZ:
                return _jsx(BonusesAndPromotionsUz, __assign({}, props));
            default:
                return _jsx(BonusesAndPromotionsRu, __assign({}, props));
        }
    };
    return BonusesAndPromotions;
}(React.Component));
BonusesAndPromotions.propTypes = {
    languageId: PropTypes.number.isRequired,
    getSubscribeStatusAction: PropTypes.func.isRequired,
    createSubscribeCampaignAction: PropTypes.func.isRequired,
    client: PropTypes.object.isRequired,
    bonusData: PropTypes.any.isRequired
};
var mapToState = function (state) { return ({
    languageId: state.application.get('languageId'),
    bonusData: state.application.get('bonus'),
    user: state.auth.user,
    client: state.application.get('client'),
    isVerified: (state.application.get('profile').gambler || {}).isVerified,
    authenticated: state.auth.authenticated
}); };
var mapDispatchToProps = function (dispatch) { return bindActionCreators({
    getSubscribeStatusAction: getSubscribeStatusAction,
    createSubscribeCampaignAction: createSubscribeCampaignAction
}, dispatch); };
export default connect(mapToState, mapDispatchToProps)(BonusesAndPromotions);



// WEBPACK FOOTER //
// ./src/components/info/bonusesAndPromotions/BonusesAndPromotions.jsx